import React from 'react';
import JoshSvg from "../components/JoshSvg";

const Josh = (props) => {

    return (
        <section className="josh" {...props}>
            <div className="portrait">
				<div className="portrait-inner">
					<JoshSvg />
					<JoshSvg />
					<JoshSvg />
					<JoshSvg />
				</div>
            </div>
        </section>
    );

};

export default Josh;


// WEBPACK FOOTER //
// ./src/js/views/Josh.js